import React from "react";
import { Box } from "@chakra-ui/layout";
import { Button } from "@chakra-ui/button";
import { HomeIcon } from "../../styles/icons";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from "@chakra-ui/react";

export interface MenuItemProps {
  title: string;
  target: string;
  icon: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  children?: React.ReactNode;
}

export const DesktopSubMenuItem = ({ title, target, icon }: MenuItemProps) => (
  <AccordionPanel pb={4} p="0">
    <Button
      as={Link}
      to={target}
      w="100%"
      height="50px"
      justifyContent="start"
      paddingTop="4"
      paddingBottom="4"
      paddingLeft="4"
      paddingRight="8"
      shadow="md"
      fontWeight="600"
      borderRadius="none"
      fontSize="sm"
      color="cherryUi.800"
    >
      <Box as="span" display="block" color="cherryUi.800" fontSize="sm" mr={2}>
        {icon}
      </Box>
      {title}
    </Button>
  </AccordionPanel>
);

export const DesktopMenuItem = ({
  children,
  title,
  target,
  icon,
}: MenuItemProps) => (
  <AccordionItem bgColor="cherryUi.700">
    <h2>
      <AccordionButton>
        <Button
          as={Link}
          to={target}
          borderRadius="none"
          flex="1"
          textAlign="left"
          background="none"
          color="white"
          justifyContent="left"
          _hover={{ bgColor: "transparent" }}
          _focus={{ bgColor: "transparent" }}
        >
          <Box as="span" display="block" color="white" fontSize="sm" mr={2}>
            {icon}
          </Box>
          {title}
        </Button>
        {children && <AccordionIcon color="white" />}
      </AccordionButton>
    </h2>
    {children}
  </AccordionItem>
);

export const MobileSubMenuItem = ({ title, target, icon }: MenuItemProps) => (
  <AccordionPanel pb={4} p="0">
    <Button
      as={Link}
      to={target}
      w="100%"
      height="50px"
      justifyContent="start"
      paddingTop="4"
      paddingBottom="4"
      paddingLeft="4"
      paddingRight="8"
      shadow="md"
      fontWeight="600"
      borderRadius="none"
      fontSize="sm"
      color="cherryUi.800"
    >
      <Box as="span" display="block" color="cherryUi.800" fontSize="sm" mr={2}>
        {icon}
      </Box>
      {title}
    </Button>
  </AccordionPanel>
);

export const MobileMenuItem = ({
  children,
  title,
  target,
  icon,
}: MenuItemProps) => (
  <AccordionItem bgColor="cherryUi.700">
    <h2>
      <AccordionButton>
        <Button
          as={Link}
          to={target}
          borderRadius="none"
          flex="1"
          textAlign="left"
          background="none"
          color="white"
          justifyContent="left"
          _hover={{ bgColor: "transparent" }}
        >
          <Box as="span" display="block" color="white" fontSize="sm" mr={2}>
            {icon}
          </Box>
          {title}
        </Button>
        {children && <AccordionIcon color="white" />}
      </AccordionButton>
    </h2>
    {children}
  </AccordionItem>
);

export const HomeMenu = ({ isDesktop }: { isDesktop: boolean }) => {
  const MenuItem = isDesktop ? DesktopMenuItem : MobileMenuItem;
  const SubMenuItem = isDesktop ? DesktopSubMenuItem : MobileSubMenuItem;

  return (
    <Accordion allowToggle width="100%">
      <MenuItem target="/" icon={<HomeIcon boxSize="20px" />} title="Home" />
    </Accordion>
  );
};
